import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class WebhookSettingsService {
    private baseUrl: string = '';
    private webhooksApiUrl: string = '';

    public constructor(
        private appService: AppService,
        public http: HttpClient,
        @Inject('WEBHOOKS_API_URL') webhooksApiUrl: string,
        @Inject('API_BASE_URL') baseUrl: string,
    ) {
        this.baseUrl = baseUrl;
        this.webhooksApiUrl = webhooksApiUrl;
    }

    public get = (creditorId: string): Observable<any> => {
        const apipath: string =
            '/webhook-handler-settings/creditor/' + creditorId;
        const fullPath: string = this.webhooksApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public getOperationTypes = (): Observable<any> => {
        const apipath: string = 'webhooks/settings/operationtypes';
        const fullPath: string = this.baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public getContentTypes = (): Observable<any> => {
        const apipath: string = 'webhooks/settings/contenttypes';
        const fullPath: string = this.baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public post = (creditorId: string, payload: any): Observable<any> => {
        const apipath: string =
            'webhooks/creditors/' + creditorId + '/settings';

        const fullPath: string = this.baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.post<any>(fullPath, payload, options);
    };

    public update = (creditorId: string, payload: any): Observable<any> => {
        const apipath: string = '/webhook-handler-settings/update';

        const fullPath: string = this.webhooksApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.post<any>(
            fullPath,
            {
                ...payload,
                creditorId,
            },
            options,
        );
    };
}
